import '@assets/styles/pages/static-details.scss';
import { ReactElement, useEffect } from 'react';
import { defaultStaticDetailFormInitialValues } from '.';
import { FormSection } from '@components/contractor360KAE/components/staticDetailsForm/formSection';
import { useBasicDetailsQuery } from '@services/hooks/enduser-details/useBasicDeailsQuery';
import { useFormik } from 'formik';
import { useEndUserStore } from '@store/enduser';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { numberValueCheck, stringValueCheck } from '@helper/formControl';
import { get18YearsAgo } from '@helper/utils';

export const StaticDetailsForm = (): ReactElement => {
	const { isEditing, isFormEdit, formId } = useEndUserStore();

	const {
		data: getBasicFormData,
		isFetching: isGetBasicFormFetching,
		error: isGetBasicFormError,
	} = useBasicDetailsQuery(formId, isFormEdit);

	const formik = useFormik({
		initialValues: defaultStaticDetailFormInitialValues,
		onSubmit: () => {},
	});

	const commonFormProps = {
		formik,
		isEditing,
		getBasicFormData,
		formId: formId,
	};

	useEffect(() => {
		if (formId && getBasicFormData) {
			const updatedValue = {
				...formik.values,
				birth_date:
					getBasicFormData?.dateofbirth && new Date(getBasicFormData?.dateofbirth)
						? new Date(getBasicFormData?.dateofbirth)
						: get18YearsAgo(),
				primary_number: stringValueCheck(getBasicFormData.phone),
				wedding_anniversary: getBasicFormData.weddinganniversary_c,
				samaj: stringValueCheck(getBasicFormData.samaj),
				permanent_address: stringValueCheck(getBasicFormData.permanent_address1_c),
				permanent_street: stringValueCheck(getBasicFormData.permanentstreet_c),
				permanent_zipcode: numberValueCheck(getBasicFormData.permanentzipcode_c),
				permanent_state: stringValueCheck(getBasicFormData.permanentstate_c),
				permanent_city: stringValueCheck(getBasicFormData.permanentcity_c),
				permanent_town: `${getBasicFormData.town_code_c} - ${getBasicFormData.town_name_c}`,
				website: stringValueCheck(getBasicFormData?.website),
			};
			formik.setValues(updatedValue);
			if (isFormEdit) {
				formik.validateForm(updatedValue).then((errors) => {
					Object.keys(errors).forEach((fieldName) => {
						formik.setFieldTouched(fieldName, true, true);
					});
				});
			}
		}
		// eslint-disable-next-line
	}, [getBasicFormData, formId, isFormEdit]);

	return (
		<section className="static-details-section">
			<div className="container">
				<Wrapper isLoaderVisible={isGetBasicFormFetching} isError={isGetBasicFormError}>
					<form onSubmit={formik.handleSubmit}>
						<ul className="user-details-wrapper row">
							<FormSection {...commonFormProps} />
						</ul>
					</form>
				</Wrapper>
			</div>
		</section>
	);
};
